import request from '@/utils/request'

//创建工单
export function saveCaseApi(data){
  return request({
    url:"/api-sp/sp/case/saveCase",
    method:"post",
    data:data,
  })
}

//创建获取产品线
export function getProductApi(data){
  return request({
    url:"/api-sp/sp/case/getProduct",
    method:"post",
    data:data,
  })
}

//获取版本号
export function getVersionApi(data){
  return request({
    url:"/api-sp/sp/case/getVersion",
    method:"post",
    data:data,
  })
}

//获取时区
export function getTimeZoneApi(data){
  return request({
    url:"/api-sp/sp/case/getTimeZone",
    method:"post",
    data:data,
  })
}

//上传文件
export function uploadFilesApi(data,config){
  return request({
    url:"/api-sp/sp/case/uploadFiles",
    method:"post",
    onUploadProgress:config.onUploadProgress,
    data:data,
  })
}

//获取工单列表
export function getCaseListApi(data){
  return request({
    url:"/api-sp/sp/case/caseList",
    method:"post",
    data:data,
  })
}

//获取工单详情
export function getCaseInfoApi(data){
  return request({
    url:"/api-sp/sp/case/caseInfo",
    method:"post",
    data:data,
  })
}

//升级工单
export function upgradeCaseApi(data){
  return request({
    url:"/api-sp/sp/case/upgradeCase",
    method:"post",
    data:data,
  })
}

//升级工单
export function saveCommentApi(data){
  return request({
    url:"/api-sp/sp/case/saveComment",
    method:"post",
    data:data,
  })
}

//获取评价内容
export function getCommentApi(data){
  return request({
    url:"/api-sp/sp/case/getComment",
    method:"post",
    data:data,
  })
}

//获取邮件详情
export function getEmailApi(data){
  return request({
    url:"/api-sp/sp/case/getEmail",
    method:"post",
    data:data,
  })
}

//获取日报详情
export function getDailyApi(data){
  return request({
    url:"/api-sp/sp/case/getDaily",
    method:"post",
    data:data,
  })
}

//详情下载附件
export function downloadApi(data){
  return request({
    url:"/api-file/kb/filedfs/download",
    method:"post",
    data:data,
    responseType: 'blob',
    headers:{
      'Content-Type': 'application/json; charset=UTF-8',
    },
  })
}

//获取kb文章列表
export function getKbArticlesApi(data){
  return request({
    url:"/api-sp/sp/case/getKbArticles",
    method:"post",
    data:data,
  })
}